import { useState } from "react";
import CountUp from "react-countup";
import ReactVisibilitySensor from "react-visibility-sensor";

export default function Counter({
  counterValue,
  applyCounteClassName,
  ...otherprops
}: { counterValue : number, applyCounteClassName : string}) {
  const [isVisible, setIsVisible] = useState(false);

  const handleVisisbility = (visible : boolean) => setIsVisible(visible);
  return (
    <ReactVisibilitySensor 
      partialVisibility 
      onChange={handleVisisbility}
    >
      {isVisible ? (
        <CountUp
          end={counterValue}
          start={0}
          duration={0.6}
          useEasing={true}
          separator={","}
          decimals={
            counterValue % 1 !== 0
              ? counterValue.toString().split(".")[1].length
              : 0
          }
          className={applyCounteClassName}
          {...otherprops}
        />
      ) : (
        <span style={{ visibility: "hidden" }}> f</span>
      )}
    </ReactVisibilitySensor>
  );
}
